import React from 'react';
import specializedTestingImage from './assets/advanced_testing_solutions.png';
import specializedTestingBackground from './assets/specialized_testing_bg.png';

// Import images for the cards
import securityTestingImage from './assets/security_testing_image2.png';
import performanceTestingImage from './assets/performance_testing_image2.png';
import accessibilityTestingImage from './assets/accessibility_testing_image.png';
import compatibilityTestingImage from './assets/compatibility_testing_image.png';
import localizationTestingImage from './assets/localization_testing_image.png';
import apiTestingImage from './assets/api_testing_image.png';

import ContactButton from './ContactButton';

const SpecializedTesting = () => {
    return (
        <div className="bg-white min-h-screen">
            <div className="mx-auto px-4 pb-8 pt-0 sm:px-6 lg:px-8">
                <header 
                    className="relative bg-cover bg-center text-white lg:h-72 flex flex-col justify-center items-center mb-16 text-center"
                    style={{ backgroundImage: `url(${specializedTestingBackground})`, backgroundPosition: 'center' }}
                >
                    <h1 className="text-5xl lg:text-7xl font-extrabold text-center pb-4 mb-6 bg-clip-text text-black">
                        Specialized Assurance Services
                    </h1>
                    <p className="text-2xl text-gray-600 max-w-3xl mx-auto">
                        Advanced testing solutions for complex software challenges.
                    </p>
                </header>

                <Section
                    title="Advanced Testing Solutions"
                    image={specializedTestingImage}
                    alt="Specialized Testing"
                >
                    <p className="text-lg  text-left mb-6">
                        At Firebucks, we offer specialized testing services designed to address unique and complex testing requirements. Our advanced testing methodologies ensure your software meets the highest standards of quality and performance.
                    </p>
                </Section>

                <section className="w-full bg-gray-100 py-16">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h2 className="text-4xl font-bold text-gray-800 mb-8 text-center">Our Specialized Testing Services</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            <Card
                                image={securityTestingImage}
                                title="Security Testing"
                                description="Comprehensive security assessments to identify vulnerabilities and protect against threats."
                            />
                            <Card
                                image={performanceTestingImage}
                                title="Performance Testing"
                                description="Advanced performance analysis to ensure optimal speed, scalability, and stability."
                            />
                            <Card
                                image={accessibilityTestingImage}
                                title="Accessibility Testing"
                                description="Ensuring your software is accessible to all users, including those with disabilities."
                            />
                            <Card
                                image={compatibilityTestingImage}
                                title="Compatibility Testing"
                                description="Testing across multiple platforms, browsers, and devices to ensure consistent functionality."
                            />
                            <Card
                                image={localizationTestingImage}
                                title="Localization Testing"
                                description="Validating software functionality across different languages and cultural contexts."
                            />
                            <Card
                                image={apiTestingImage}
                                title="API Testing"
                                description="Comprehensive testing of API functionality, security, and performance."
                            />
                        </div>
                    </div>
                </section>
            </div>
            <ContactButton />
        </div>
    );
};

const Section = ({ title, children, image, alt }) => (
    <section className="flex flex-col md:flex-row items-center mb-32">
        <div className="w-full md:w-1/2 mb-8 md:mb-0 flex justify-center items-center">
            <img src={image} alt={alt} className="w-2/3 h-auto rounded-lg shadow-lg" />
        </div>
        <div className="w-full md:w-1/2 md:px-8">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">{title}</h2>
            <div className="space-y-4">
                {children}
            </div>
        </div>
    </section>
);

const Card = ({ image, title, description }) => (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden lower section">
        <img src={image} alt={title} className="w-full h-48 object-contain" />
        <div className="p-6">
            <h3 className="text-xl font-semibold mb-2">{title}</h3>
            <p className="text-gray-600">{description}</p>
        </div>
    </div>
);

export default SpecializedTesting; 